import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Link, NavLink } from "react-router-dom";
import { RiFileSearchFill } from "react-icons/ri";
import { AiFillGithub } from "react-icons/ai";
import {
  FaLinkedin,
  FaUserTie,
  FaCode,
  FaRegUserCircle,
  FaShareAlt,
} from "react-icons/fa";
import { SiSkype } from "react-icons/si";
import { MdOutlineConnectWithoutContact } from "react-icons/md";
import { BiErrorAlt } from "react-icons/bi";
import AOS from "aos";
import "aos/dist/aos.css";
import { ReactComponent as BurgerSVG } from "../../images/hamburger.svg";
import { ReactComponent as ClosedIcon } from "../../images/closed.svg";
// import { ReactComponent as ShareIcon } from "../../images/share-icon.svg";

const Navbar = () => {
  const [modal, openModal] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 3000 });
    AOS.refresh();
  }, []);

  const url = "https://portfolio-eight-blush-47.vercel.app";

  const shareFunction = async () => {
    try {
      await navigator.share({
        text: "Check out Adithya's portfolio for Web Development Purpose",
        url: url,
      });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <nav className="nav-container">
        <ul className="nav-ul">
          <NavLink to="/" className="nav-box">
            <span className="nav-icons-hover">
              <FaCode className="nav-icons" style={{ color: "#16F529" }} />
            </span>
            <li className="nav-list"></li>
          </NavLink>

          <NavLink to="/projects" className="nav-box">
            <span className="nav-icons-hover">
              <RiFileSearchFill className="nav-icons" />
            </span>
            <li className="nav-list">Projects</li>
          </NavLink>

          <NavLink to="/experiences" className="nav-box">
            <span className="nav-icons-hover">
              <FaUserTie className="nav-icons" />
            </span>
            <li className="nav-list">Experiences</li>
          </NavLink>

          <NavLink to="/about" className="nav-box">
            <span className="nav-icons-hover">
              <FaRegUserCircle className="nav-icons" />
            </span>
            <li className="nav-list">About Me</li>
          </NavLink>

          <NavLink to="/contact" className="nav-box">
            <span className="nav-icons-hover">
              <MdOutlineConnectWithoutContact className="nav-icons" />
            </span>
            <li className="nav-list">Contact</li>
          </NavLink>

          <NavLink to="*" className="nav-box">
            <span className="nav-icons-hover">
              <BiErrorAlt className="nav-icons" style={{ color: "red" }} />
            </span>
            <li className="nav-list" style={{ color: "red" }}>
              ErrorPage
            </li>
          </NavLink>
        </ul>
      </nav>

      <span className="small-icon-position">
        <BurgerSVG
          className="small-nav-icons"
          onClick={() => openModal(true)}
        />
      </span>

      {modal && (
        <div className="small-container" data-aos="fade-down">
          <span className="small-icon-close">
            <ClosedIcon
              className="small-nav-icons"
              onClick={() => openModal(false)}
            />
          </span>
          <ul className="sm-ul">
            <Link to="/" onClick={() => openModal(false)}>
              <span className="sm-nav-box">
                <span>
                  <FaCode className="small-nav-box-icon" />
                </span>
                <li className="list-text">Home</li>
              </span>
            </Link>

            <Link to="/projects" onClick={() => openModal(false)}>
              <span className="sm-nav-box">
                <span>
                  <RiFileSearchFill className="small-nav-box-icon" />
                </span>
                <li className="list-text">Projects</li>
              </span>
            </Link>

            <Link to="/experiences" onClick={() => openModal(false)}>
              <span className="sm-nav-box">
                <span>
                  <FaUserTie className="small-nav-box-icon" />
                </span>
                <li className="list-text">Experiences</li>
              </span>
            </Link>

            <Link to="/about" onClick={() => openModal(false)}>
              <span className="sm-nav-box">
                <span>
                  <FaRegUserCircle className="small-nav-box-icon" />
                </span>
                <li className="list-text">About Me</li>
              </span>
            </Link>

            <Link to="/contact" onClick={() => openModal(false)}>
              <span className="sm-nav-box">
                <span>
                  <MdOutlineConnectWithoutContact className="small-nav-box-icon" />
                </span>
                <li className="list-text">Contact</li>
              </span>
            </Link>

            <Link to="/*" onClick={() => openModal(false)}>
              <span className="sm-nav-box">
                <span>
                  <BiErrorAlt className="small-nav-box-icon" />
                </span>
                <li className="list-text">ErrorPage</li>
              </span>
            </Link>
          </ul>
          <span className="nav-b-links">
            <span>
              <a
                className="classa"
                href="https://github.com/Adithyavarun-creator"
                target="_blank"
                rel="noreferrer"
              >
                <AiFillGithub
                  style={{ color: "#171515" }}
                  className="small-nav-box-icon"
                />
              </a>
            </span>
            <span>
              <a
                className="classa"
                href="https://www.linkedin.com/in/adithya-varun-9a65b8177/"
                target="_blank"
                rel="noreferrer"
              >
                <FaLinkedin
                  style={{ color: "#0A66C2" }}
                  className="small-nav-box-icon"
                />
              </a>
            </span>
            <span>
              <a
                className="classa"
                href="skype:adithyavarun95?chat"
                target="_blank"
                rel="noreferrer"
              >
                <SiSkype
                  style={{ color: "#00aff0" }}
                  className="small-nav-box-icon"
                />
              </a>
            </span>

            <span>
              <a className="classa" rel="noreferrer">
                <FaShareAlt
                  onClick={shareFunction}
                  style={{ color: "#FFFF00" }}
                  className="small-nav-box-icon"
                />
              </a>
            </span>
          </span>
        </div>
      )}
    </>
  );
};

export default Navbar;
